import { Leaf, HeartPulse, Recycle, Mountain } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const PRINCIPLES = [
  {
    icon: HeartPulse,
    title: "Good Food Is Personal",
    text: "Menus shaped around your guests — dietary, cultural, comforting or performance-driven.",
  },
  {
    icon: Leaf,
    title: "Local & Seasonal",
    text: "The freshest seasonal produce from New Zealand growers and artisans.",
  },
  {
    icon: Recycle,
    title: "Plastic-Free",
    text: "Low-waste hospitality, plastic-free wherever possible.",
  },
  {
    icon: Mountain,
    title: "Honouring the Earth",
    text: "We tread lightly, honouring the land that makes every stay possible.",
  },
];

export default function Ethos() {
  return (
    <section
      id="ethos"
      className="relative bg-surface py-28 md:py-40 border-y border-white/10"
      data-testid="ethos"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>Our Ethos</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
                Our ethos:{" "}
                <em className="italic text-metallic-gold">Good Food Is Personal</em>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 font-sans text-base md:text-lg text-ink/60 max-w-md leading-relaxed">
              We cater to every guest — dietary needs, allergies, cultural preferences,
              performance nutrition, family favourites, or simply the best comfort food
              you&rsquo;ve ever had. Beautifully sourced, thoughtfully made.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {PRINCIPLES.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08}>
                <div className="bg-surface p-8 md:p-10 h-full">
                  <p.icon className="h-7 w-7 text-gold" strokeWidth={1.4} />
                  <h3 className="mt-6 font-serif text-2xl md:text-3xl text-ink leading-tight">
                    {p.title}
                  </h3>
                  <p className="mt-3 font-sans text-sm text-ash leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
